import { GroupuiText } from '@group-ui/group-ui-react';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { LOCATION } from '@/app/consts/location.ts';
import { classNames } from '@/app/utils/tailwinds/classNames.ts';

export function AvatarActionContent() {
  const { t } = useTranslation();
  const { pathname } = useLocation();

  return (
    <div>
      <Link to={LOCATION.PROFILE}>
        <GroupuiText
          className={classNames(
            'hover:text-[#004666] mb-5',
            pathname === LOCATION.PROFILE ? 'text-[#20607E]' : ''
          )}
        >
          {t('actions.profile')}
        </GroupuiText>
      </Link>
      <Link to={LOCATION.LOGOUT}>
        <GroupuiText className='hover:text-[#004666] active:text-[#20607E]'>
          {t('actions.logout')}
        </GroupuiText>
      </Link>
    </div>
  );
}
